import { createSelector } from "@ngrx/store";
import { IStore } from "../store";

export const getPaymentsState = createSelector(
    (store: IStore) => store.payments,
    store => store,
);
